import { styled } from '@mui/system';

const StepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.vars.palette.secondary.textIconColor,
  "& path": {
    fill: theme.vars.palette.secondary.textIconColor,
  },
  display: 'flex',
  ...(ownerState.active && {
    color: theme.vars.palette.primary.main,
    "& path": {
      fill: theme.vars.palette.primary.main,
    },
    padding: theme.spacing(1.5),
    background: theme.vars.palette.secondary.main,
    border: `1px solid ${theme.vars.palette.primary.main}`,
    borderRadius: theme.spacing(1)
  }),
  ...(ownerState.completed && {
    color: theme.vars.palette.primary.main,
    "& path": {
      fill: theme.vars.palette.primary.main,
    }
  })
}));

function StepIcon(props) {
  const { active, completed, className, icon } = props;

  return (
    <StepIconRoot ownerState={{ completed, active }} className={className}>
      {icon}
    </StepIconRoot>
  );
}

export const MuiStepLabel = {
  defaultProps: {
    StepIconComponent: StepIcon
  }
}
